import { c as _c } from "react/compiler-runtime";
import { Dropdown } from '@onefootprint/ui';
import useEntityId from '@/entity/hooks/use-entity-id';
import useLabelText from '@/entity/hooks/use-label-text';
import useEditLabel from '@/hooks/use-edit-label';
import { LABEL_KIND_VALUES } from './fraud-label';
const FraudLabelMenuItems = () => {
  const $ = _c(6);
  const labelT = useLabelText();
  const entityId = useEntityId();
  const editLabelMutation = useEditLabel();
  let t0;
  if ($[0] !== editLabelMutation || $[1] !== entityId || $[2] !== labelT) {
    t0 = LABEL_KIND_VALUES.map(kind => <Dropdown.Item key={kind} onSelect={() => editLabelMutation.mutate({
      body: {
        kind
      },
      path: {
        fpId: entityId
      }
    })} className="h-10">{labelT(kind)}</Dropdown.Item>);
    $[0] = editLabelMutation;
    $[1] = entityId;
    $[2] = labelT;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== t0) {
    t1 = <Dropdown.Group>{t0}</Dropdown.Group>;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default FraudLabelMenuItems;